import { ReactNode } from "react";
import { DashboardGroupBy } from "../../../__generated__/api";
import Registry from "../../../base-registry";
import TicketItem from "../ticket-item";

export interface GroupDescriptor {
    id: string;
    icon: ReactNode;
    title: string;
    subtitle?: string;

}

export class GroupBy {
    public constructor(public readonly groupBy: DashboardGroupBy) {
        // do nothing

    }

    // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars
    public getGroup(id: string, chats: TicketItem[]): GroupDescriptor {
        throw new Error(`GroupBy.getGroup not implemented for ${id}`);
    }

    // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars
    public getGroupId(_ticket: TicketItem): string | undefined {
        return undefined;
    }
}

interface GroupByCreator {
    shouldCreate(groupBy: DashboardGroupBy): boolean;
}

export const GROUP_REGISTRY = new Registry<typeof GroupBy & GroupByCreator>();
